// React Router
import { Route, Routes, useLocation } from "react-router-dom";

// Styles
import "./App.css";
import "./assets/css/general/fontStyle.css";

// Context
import { ThemeProvider } from "./contexts/ThemeContext";

// ==================== USER IMPORTS ====================
// import AIProductCustomize from "./components/customer/productdetailpage/aiProductCustomize/AIProductCustomize";
import ProductDetail from "./components/customer/productdetailpage/ProductDetailPage";
import ShopDetailPage from "./components/customer/ShopDetailPage/ShopDetailPage";
import AboutPage from "./screens/customer/about/AboutUs";
import CPPage from "./screens/customer/category/CategoryPage";
import ContactPage from "./screens/customer/contactus/ContactUs";
import Home from "./screens/customer/home/Home";
import Shops from "./screens/customer/shops/Shops";

// User - Auth
import LoginPage from "./screens/customer/auth/authlogin/LoginPage";
import SignUpPage from "./screens/customer/auth/authsignup/SignUpPage";
import AuthPage from "./screens/customer/auth/profile/Profile";

// User - Account & Cart
import AddToCart from "./screens/customer/addtocart/AddtoCart";

// User - Settings & Profile
import EditProfilePage from "./subscreens/customer/account/editprofile/EditProfile";
import ChangePassword from "./subscreens/customer/account/customersettings/changepassword/ChangePassword";
import MyTicketsPage from "./subscreens/customer/account/customersettings/mytickets/MyTickets";
import PrivacySettings from "./subscreens/customer/account/customersettings/privacysetting/PrivacySettings";
import UserNotifications from "./subscreens/customer/account/customersettings/customernotifications/UserNotifications";
import SettingsPage from "./subscreens/customer/account/customersettings/UserSettings";

// User - Other
import BecomeSeller from "./screens/seller/becomeaseller/BecomeASeller";
import BlogsPage from "./screens/customer/blog/Blog";
import FavoritesPage from "./subscreens/customer/account/favorites/FavoritesPage";
import MyOrders from "./subscreens/customer/account/myorders/MyOrders";
import OrderDetails from "./subscreens/customer/account/orderdetails/OrderDetails";
import BlogDetailPage from "./subscreens/customer/blog/BlogDetailpage";
import SupportHelpPage from "./subscreens/customer/account/support&help/Support&Help";

// User - Terms & Conditions (customer-facing)
import { TermsConditionsPage } from "./components/customer/termsconditions/TermsConditions";

// ==================== SELLER IMPORTS ====================
import DashboardView from "./screens/seller/dashboard/SellerDashboardManagement";
import SellerEarningsManagement from './screens/seller/sellertopup/Sellertopup';
import SellerOrdersManagement from "./screens/seller/orders/OrdersManagement";
import OrderView from "./subscreens/seller/orders/SellerOrderView";
import ProductsManagement from "./screens/seller/products/SellerProductsManagement";
import ReportingManagement from "./screens/seller/reporting/SellerReporting";
import SupportManagement from "./screens/seller/support/SellerSupportHelp";
import TicketView from "./subscreens/seller/support/ticketview/SellerTicketView";
import SettingsManagement from "./screens/seller/settings/SellerSettings";
import EditStore from "./subscreens/seller/settings/editstore/EditStore";
import SellerLogin from "./screens/seller/auth/SellerLogin";
import SellerSignUp from "./screens/seller/auth/SellerSignUp";
import TermsConditions from './subscreens/seller/settings/termsConditions/TermsConditions';
import SellerReturnsManagement from "./screens/seller/returnsManagement/ReturnsManagement";
import ReturnView from "./subscreens/seller/returnView/ReturnView";

// ==================== ADMIN IMPORTS ====================
import BlogManagement from "./screens/admin/blog/AdminBlogMangement";
import CategoryManagement from "./screens/admin/category/AdminCategoryManagement";
import DashboardManagement from "./screens/admin/dashboard/AdminDashboardManagement";
import EarningsManagement from "./screens/admin/admintopup/AdminTopupManagement";
import MarqueeManagement from "./screens/admin/marqueemangement/AdminMarqueeMangement";
import ProductManagement from "./screens/admin/product/AdminProductManagement";
import ShopsManagement from "./screens/admin/Shop/AdminShopsManagement";
import SubAdminManagement from "./screens/admin/subAdminsmgmt/SubAdminManagement";
import SupportTickets from "./screens/admin/supportticketsmanagement/AdminSupportTicketsManagement";
import Notifications from "./screens/admin/adminnotifications/AdminNotifications";
import AdminLoginPage from "./screens/admin/Auth/adminlogin/AdminLogin";
import SellerProfilePage from "./screens/seller/profile/SellerProfile";
import AdminTicketView from "./screens/admin/supportticketsmanagement/adminticketView/AdminTicketView";
import HeroSectionManagement from "./screens/admin/herosectionmgmt/AdminHerosectionmanagement";
import AdminProfile from "./screens/admin/Auth/adminprofile/Adminprofile";
import NotFound from "./components/general/not-found/NotFound";
import AccountPage from "./screens/customer/account/MyAccount";
import CustomerNotifications from "./screens/customer/notification/Notification";
import FAQManagement from "./screens/admin/faqmanagement/AdminFAQManagement";
import SellerNotifications from "./screens/seller/sellerNotifications/SellerNotifications";
import AdminSettingsManagement from "./screens/admin/settings/AdminSetting";
import ProductChatSeller from "./components/customer/productdetailpage/productchatseller/ProductChatSeller";
import SellerMessages from "./screens/seller/products/sellerMessages/SellerMessages";
import AdminOrdersManagement from "./screens/admin/ordersManagement/AdminOrdersManagement";
import AdminOrderView from "./screens/admin/ordersManagement/AdminOrdersView";

// Wrapper component for seller routes
const SellerRouteWrapper = ({ children }) => (
  <ThemeProvider>{children}</ThemeProvider>
);

function App() {
  return (
    <Routes>
      {/* USER ROUTES */}

      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/shops" element={<Shops />} />
      <Route path="/shop-details" element={<ShopDetailPage />} />
      <Route path="/shop-detail" element={<CPPage />} />
      <Route path="/categories" element={<CPPage />} />
      <Route path="/product" element={<ProductDetail />} />
      {/* <Route path="/product/customize" element={<AIProductCustomize />} /> */}
      <Route path="/product/chat-seller" element={<ProductChatSeller />} />
      <Route path="/blogs" element={<BlogsPage />} />
      <Route path="/blogs/:slug" element={<BlogDetailPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/profile" element={<AuthPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/edit-profile" element={<EditProfilePage />} />
      <Route path="/cart" element={<AddToCart />} />
      <Route path="/favorites" element={<FavoritesPage />} />
      <Route path="/orders" element={<MyOrders />} />
      <Route path="/order-details" element={<OrderDetails />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/change-password" element={<ChangePassword />} />
      <Route path="/settings/notifications" element={<UserNotifications />} />
      <Route path="/settings/privacy" element={<PrivacySettings />} />
      <Route path="/settings/terms" element={<TermsConditionsPage />} />
      <Route path="/support" element={<SupportHelpPage />} />
      <Route path="/my-tickets" element={<MyTicketsPage />} />
      <Route path="/notifications" element={<CustomerNotifications />} />
      <Route path="/become-seller" element={<BecomeSeller />} />

      {/* SELLER ROUTES */}

      <Route path="/seller/login" element={<SellerRouteWrapper><SellerLogin /></SellerRouteWrapper>} />
      <Route path="/seller/signup" element={<SellerRouteWrapper><SellerSignUp /></SellerRouteWrapper>} />
      <Route path="/seller/dashboard" element={<SellerRouteWrapper><DashboardView /></SellerRouteWrapper>} />
      <Route path="/seller/messages" element={<SellerRouteWrapper><SellerMessages /></SellerRouteWrapper>} />
      <Route path="/seller/products" element={<SellerRouteWrapper><ProductsManagement /></SellerRouteWrapper>} />
      <Route path="/seller/orders" element={<SellerRouteWrapper><SellerOrdersManagement /></SellerRouteWrapper>} />
      <Route path="/seller/orders/order-detail" element={<SellerRouteWrapper><OrderView /></SellerRouteWrapper>} />
      <Route path="/seller/returns" element={<SellerRouteWrapper><SellerReturnsManagement /></SellerRouteWrapper>} />
      <Route path="/seller/returns/return-detail" element={<SellerRouteWrapper><ReturnView /></SellerRouteWrapper>} />
      <Route path="/seller/earnings" element={<SellerRouteWrapper><SellerEarningsManagement /></SellerRouteWrapper>} />
      <Route path="/seller/reporting" element={<SellerRouteWrapper><ReportingManagement /></SellerRouteWrapper>} />
      <Route path="/seller/support" element={<SellerRouteWrapper><SupportManagement /></SellerRouteWrapper>} />
      <Route path="/seller/terms" element={<SellerRouteWrapper><TermsConditions /></SellerRouteWrapper>} />
      <Route path="/seller/support/support-detail" element={<SellerRouteWrapper><TicketView /></SellerRouteWrapper>} />
      <Route path="/seller/settings" element={<SellerRouteWrapper><SettingsManagement /></SellerRouteWrapper>} />
      <Route path="/seller/editstore" element={<SellerRouteWrapper><EditStore /></SellerRouteWrapper>} />
      <Route path="/seller/notifications" element={<SellerRouteWrapper><SellerNotifications /></SellerRouteWrapper>} />
      <Route path="/seller/profile" element={<SellerRouteWrapper><SellerProfilePage /></SellerRouteWrapper>} />
      <Route path="/seller/shop-settings" element={<SellerRouteWrapper><SellerProfilePage /></SellerRouteWrapper>} />
      <Route path="/seller/change-password" element={<SellerRouteWrapper><SellerProfilePage /></SellerRouteWrapper>} />

      {/* ADMIN ROUTES */}

      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/profile" element={<AdminProfile />} />
      <Route path="/admin/dashboard" element={<DashboardManagement />} />
      <Route path="/admin/subadmins" element={<SubAdminManagement />} />
      <Route path="/admin/shops" element={<ShopsManagement />} />
      <Route path="/admin/categories" element={<CategoryManagement />} />
      <Route path="/admin/products" element={<ProductManagement />} />
      <Route path="/admin/orders" element={<AdminOrdersManagement />} />
      <Route path="/admin/orders/order-detail" element={<AdminOrderView />} />
      <Route path="/admin/tickets" element={<SupportTickets />} />
      <Route path="/admin/support/ticket-detail" element={<AdminTicketView />} />
      <Route path="/admin/blogs" element={<BlogManagement />} />
      <Route path="/admin/marquee" element={<MarqueeManagement />} />
      <Route path="/admin/earnings" element={<EarningsManagement />} />
      <Route path="admin/hero-section" element={<HeroSectionManagement />} />
      <Route path="/admin/notifications" element={<Notifications />} />
      <Route path="/admin/faq" element={<FAQManagement />} />
      <Route path="/admin/settings" element={<AdminSettingsManagement />} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;